export default __webpack_public_path__ + "static/media/four.4b8cfbb3.glb";